<template>
    <!-- Modal backdrop. This what you want to place close to the closing body tag -->
    <div
        v-show="isModalOpen"
        class="fixed inset-0 z-30 flex items-end bg-black bg-opacity-50 sm:items-center sm:justify-center p-10"
    >
        <!-- Modal -->
        <div
            class="w-full flex flex-col overflow-hidden h-screen max-h-full bg-white rounded-t-lg dark:bg-gray-800 sm:rounded-lg sm:m-4"
            role="dialog"
            id="modal"
        >
            <!-- Modal body -->
            <div class="px-6 py-4 border-b dark:border-gray-500 flex justify-between items-center">
                <p class="text-lg font-semibold text-gray-700 dark:text-gray-300">Preview Block Element</p>
            </div>

            <div class="mb-6 overflow-auto h-full">
                <div class="px-6 py-4 h-full">
                    <div class="border p-3 h-full">
                        <iframe width="100%" height="100%" name="Quote preview" :title="quote.name" :src="previewUrl"></iframe>
                    </div>
                </div>
            </div>
            <footer
                class="flex flex-col items-center justify-end px-6 py-3 sm:flex-row bg-gray-50 dark:bg-gray-700"
            >
                <jet-button
                    @click="close"
                    type="button"
                    class="w-full px-5 py-3 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg sm:w-auto sm:px-4 sm:py-2 active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red"
                >
                    Cancel
                </jet-button>
            </footer>
        </div>
    </div>
    <!-- End of modal backdrop -->
</template>

<script>
import JetButton from '@/Jetstream/Button';

export default {
    components: {
        JetButton
    },
    props: {
        isModalOpen: {
            type: Boolean,
            default: false,
        },
        client: {
            type: Object,
            required: false,
        },
        quote: {
            type: Object,
            required: true,
        }
    },
    setup(props, {emit}) {
        const close = () => {
            emit("close");
        }

        const previewUrl = props.client
                ? route('admin.quote.show', {client: props.client.id, quote: props.quote.id})
                : route('admin.quote-template.show', {quote_template: props.quote.id});

        return {
            close,
            previewUrl
        }
    },
}
</script>

<style scoped>

</style>
